import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const GuestRow = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space[3]} ${space[4]};
  margin-bottom: ${space[2]};
  border: 2px solid
    ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.default)};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${semantic.border.selected};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GuestInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[1]};
`;

export const GuestName = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const GuestPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const Indicator = styled.span<{ $selected: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid
    ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.default)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
  background: ${({ $selected }) => ($selected ? semantic.text.primary : 'transparent')};

  &::after {
    content: '';
    display: ${({ $selected }) => ($selected ? 'block' : 'none')};
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.white};
  }
`;

export const GuestList = styled.div`
  padding-bottom: ${space[4]};
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[4]} ${space[5]};
  gap: ${space[4]};
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;
